import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = 'sman_admin_token';

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || '').join(' ');
  return e?.message || 'Errore imprevisto';
}
